module.exports = __webpack_public_path__ + "fonts/qanelas_soft_regular.8373f4be.otf";